import { LeagueNames, LeaderboardUser } from '~/Leaderboard/types/leaderboard.types'

export const formatTimeFromSec = ({
  seconds,
  timeText,
}: {
  seconds: number
  timeText: { day: string; hour: string; min: string }
}): string => {
  const days = Math.floor(seconds / 60 / 60 / 24)
  const hours = Math.floor((seconds - days * 60 * 60 * 24) / 60 / 60)
  const minutes = Math.floor((seconds - days * 60 * 60 * 24 - hours * 60 * 60) / 60)

  return `${days}${timeText.day} ${hours}${timeText.hour} ${minutes}${timeText.min}`
}

export const getWeekNumber = (): number => {
  let d = new Date()
  // Copy date so don't modify original
  d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
  // Get first day of year
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
  // Calculate full weeks to nearest Thursday
  const weekNo = Math.ceil(((+d - +yearStart) / 86400000 + 1) / 7)
  // Return week number
  return weekNo
}

export const getStartOfAllTime = (): Date => {
  return new Date(0)
}

export const getStartOfCurrentMonth = (): Date => {
  const now = new Date()
  now.setDate(1)
  now.setHours(0, 0, 1, 0)
  return now
}

export const getStartOfCurrentWeek = (): Date => {
  const now = new Date()
  const day = now.getDay()
  const diff = day === 1 ? 0 : (day + 6) % 7
  now.setDate(now.getDate() - diff)
  now.setHours(0, 0, 1, 0)
  return now
}

export const getStartOfLastMonth = (): Date => {
  const now = new Date()
  now.setDate(1)
  now.setMonth(now.getMonth() - 1)
  now.setHours(0, 0, 1, 0)
  return new Date(now)
}

export const getEndOfLastMonth = (): Date => {
  const now = new Date()
  now.setDate(1)
  now.setHours(0, 0, 0, 0)
  now.setMilliseconds(-1)
  return new Date(now)
}

export const getStartOfLastWeek = (): Date => {
  const now = new Date()
  const day = now.getDay()
  const diffToMonday = day === 0 ? 6 : day - 1
  now.setDate(now.getDate() - diffToMonday - 7)
  now.setHours(0, 0, 1, 0)
  return new Date(now)
}

export const getEndOfLastWeek = (): Date => {
  const now = new Date()
  const day = now.getDay()
  const diffToSunday = day === 0 ? 0 : 7 - day
  now.setDate(now.getDate() - diffToSunday - 1)
  now.setHours(23, 59, 59, 999)
  return new Date(now)
}

export const getBadgePosition = (position: number) => {
  switch (position) {
    case 1:
      return 'ml-48'
    case 2:
      return 'ml-24'
    case 3:
      return ''
    case 4:
      return '-ml-24'
    case 5:
      return '-ml-48'
    default:
      return ''
  }
}

export const getLeagueName = (league: number): LeagueNames => {
  switch (league) {
    case 1:
      return LeagueNames.BRONZE
    case 2:
      return LeagueNames.SILVER
    case 3:
      return LeagueNames.GOLD
    case 4:
      return LeagueNames.PLATINUM
    case 5:
      return LeagueNames.DIAMOND
    default:
      return LeagueNames.UNRANKED
  }
}

export const getUserCurrentRank = (userId: number, users: LeaderboardUser[]): number => {
  const userRank = users.findIndex((user) => user.id === userId)

  return userRank > -1 ? userRank + 1 : 0
}
